// src/components/TransactionList.js
import React from 'react';
import { useTransactions } from '../../hooks/useApi';

const TransactionList = ({ account }) => {
  const { data: transactions, loading } = useTransactions(account);

  if (loading) return <div>Chargement...</div>;

  return (
    <div className="transaction-list">
      <h3>Dernières transactions</h3>
      <ul>
        {transactions.map((transaction) => (
          <li key={transaction.id}>
            <span>{transaction.date}</span>
            <span>{transaction.description}</span>
            <span className={transaction.amount < 0 ? 'expense' : 'income'}>
              {transaction.amount} €
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TransactionList;
